<template>
  <v-container fluid>
    <v-row>
      <!-- name/title card -->
      <v-col>
        <v-card>
          <v-card-title class="headline font-weight-medium">
            Invoices
            <v-spacer />
          </v-card-title>
          <v-card-subtitle class="title font-weight-regular">{{getOrg}}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table :headers="headers" :items="getInvoices" :loading="loading">
          <template v-slot:item.amount="{item}">${{item.amount}} USD</template>

          <template v-slot:item.paid="{item}">
            <v-icon color="green" v-if="item.paid">mdi-check</v-icon>
            <v-icon color="red" v-else>mdi-close</v-icon>
          </template>

          <template v-slot:item.invoiceLink="{item}">
            <v-btn color="blue accent-4" text :href="item.invoiceLink" target="_blank">
              View
              <v-icon right dark>mdi-clipboard-arrow-right-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Invoices",
  data() {
    return {
      loading: true,
      headers: [
        { text: "Date", value: "date" },
        { text: "Amount", value: "amount" },
        { text: "Invoice Paid", value: "paid" },
        { text: "Paid On", value: "paidDate" },
        { text: "Invoice Link", value: "invoiceLink" },
      ],
    };
  },
  methods: {
    ...mapActions(["fetchInvoices"]),
  },
  computed: {
    ...mapGetters(["getInvoices", "getOrg"]),
  },
  props: {},
  created() {
    this.fetchInvoices()
      .catch(() => {
        this.setGlobalAlert({
          alert: true,
          color: 'red',
          alertTitle: "There's been a problem.",
          alertMessage:
            "Unable to retreive account information and support has been notified. Please try again shortly. ",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style>
</style>